<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>
            No momento em que celebra 70 anos, a JBS apresenta ao mundo uma
            marca que reflete a jornada de crescimento e evolução da companhia.
          </h2>
          <blockquote>
            “Partimos de uma pequena casa de carnes no interior do Brasil e nos
            tornamos uma das maiores empresas de alimentos do mundo. Somos uma
            empresa multiproteína e multigeográfica, com mais de 270 mil
            colaboradores, em mais de 20 países. Evoluímos muito, especialmente
            na última década, então é natural que nossa marca evolua também”,
            <span>destaca Gilberto Tomazoni, CEO Global da JBS.</span>
          </blockquote>
          <img
            src="../assets/img/2023/2023-1.png"
            alt=""
            class="fistItem nohover"
          />
          <p>
            As tradicionais três letras do nome da empresa continuam presentes,
            mas a escrita foi modernizada, assim como o símbolo que as
            acompanha. O novo desenho também tem a missão de simbolizar a visão
            de futuro da empresa, que está sendo construído com sólidos
            investimentos em inovação e busca ininterrupta por excelência. O tom
            azul sólido representa a robustez da empresa para seus parceiros,
            colaboradores e demais stakeholders. Ao longo do movimento dos
            parênteses são inseridos vários outros tons de azul, que simbolizam
            as várias proteínas e geografias em que a JBS está presente. Já o
            verde representa o compromisso da Companhia com a sustentabilidade
            ambiental, social, operacional e econômica.
          </p>
        </div>
        <div class="formato__warpper__item--black">
          <h2>Geração de empregos</h2>
          <p>
            A JBS e as cadeias produtivas ligadas a ela no Brasil movimentaram,
            em 2021, o equivalente a <strong>2,1% do PIB</strong> (Produto
            Interno Bruto) e contribuíram para a geração de 2,73% dos empregos
            do País. As informações constam no levantamento inédito produzido
            pela Fipe (Fundação Instituto de Pesquisas Econômicas) via Nereus
            (Núcleo de Economia Regional e Urbana da Universidade de São Paulo)
            sobre a mensuração da importância socioeconômica das atividades
            relacionadas à Companhia.
          </p>
          <p>
            Em 2023, a JBS se consolidou
            <strong>como a maior empregadora do Brasil</strong>, com 152 mil
            colaboradores diretos trabalhando em suas diversas operações no
            País. Somente entre janeiro e agosto deste ano a companhia gerou
            <strong>7,3 mil novas vagas</strong>, o que representa um aumento de
            5% em relação a dezembro de 2022. Globalmente a JBS emprega 270 mil
            colaboradores em suas mais de 400 unidades produtivas e seus
            escritórios espalhados por 20 países.
          </p>
          <span class="click" @click="handdleClick">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M17.0001 9C17.0001 13.4183 13.4184 17 9.00012 17C5.32473 16.755 1.4987 17 1.4987 16C1.5 15.5 0.998761 12.5697 1.00012 9C1.00012 4.58172 4.58184 1 9.00012 1C13.4184 1 17.0001 4.58172 17.0001 9Z"
                fill="white"
              />
              <path
                d="M17.8146 7.34176C17.0847 3.35835 13.7704 0.348083 9.70996 0.0311855C7.1172 -0.171378 4.82361 0.613296 2.89809 2.37268C-0.113394 5.12504 -0.863654 9.56944 1.05194 13.1759C1.1313 13.3258 1.14592 13.4568 1.09423 13.6197C0.887999 14.2717 0.691688 14.9275 0.49851 15.5837C0.453088 15.7388 0.414452 15.9017 0.409753 16.0625C0.381559 17.0466 1.31456 17.7665 2.27366 17.4966C2.97589 17.2987 3.67341 17.0847 4.37094 16.8696C4.51243 16.8257 4.62991 16.833 4.76148 16.9009C7.45866 18.2938 10.2148 18.3878 12.9235 17.0413C16.2107 15.4073 17.8093 12.6319 18.0004 8.94974C17.9435 8.44177 17.9143 7.88524 17.8146 7.34176ZM10.2644 16.5908C8.55455 16.8837 6.92507 16.6185 5.39061 15.8139C4.92281 15.5686 4.46492 15.5106 3.96057 15.6782C3.33614 15.886 2.7023 16.0635 2.07213 16.253C1.9557 16.288 1.81264 16.3637 1.7338 16.2321C1.6842 16.1491 1.68786 16.0087 1.71658 15.9074C1.90192 15.2559 2.08988 14.6043 2.29872 13.9595C2.45378 13.4819 2.40105 13.0459 2.16767 12.6037C-0.21677 8.08571 2.26792 2.62536 7.23937 1.45279C7.48633 1.39432 7.73746 1.34576 7.98911 1.31705C8.31908 1.27894 8.65218 1.26536 8.98372 1.24135C12.7815 1.25805 16.0159 4.02243 16.609 7.77195C17.27 11.9527 14.4527 15.8735 10.2644 16.5908Z"
                fill="#82DC64"
              />
              <path
                d="M8.97739 7.93735C7.88149 7.93735 6.78612 7.93892 5.69023 7.93631C5.31693 7.93579 5.05066 7.71338 5.01933 7.38918C4.98539 7.0326 5.20363 6.74912 5.55762 6.6943C5.61505 6.68542 5.67457 6.68438 5.73304 6.68438C7.8982 6.68438 10.0639 6.68333 12.229 6.68438C12.6472 6.68438 12.9255 6.91827 12.9417 7.27641C12.9589 7.65282 12.6958 7.93213 12.3032 7.93579C11.6511 7.94153 10.999 7.93735 10.3463 7.93787C9.89002 7.93787 9.4337 7.93735 8.97739 7.93735Z"
                fill="#82DC64"
              />
              <path
                d="M7.73896 10.0345C8.43649 10.0345 9.13454 10.0303 9.83207 10.0366C10.1244 10.0392 10.3662 10.2449 10.4252 10.5143C10.4857 10.7926 10.3594 11.0854 10.1051 11.2066C10.0028 11.2551 9.8801 11.2828 9.76681 11.2833C8.40412 11.2885 7.04143 11.2891 5.67874 11.2849C5.27934 11.2838 5.00993 11.0129 5.01568 10.6433C5.02142 10.2809 5.28612 10.0356 5.68501 10.034C6.36949 10.0309 7.05448 10.0329 7.73896 10.0329V10.0345Z"
                fill="#82DC64"
              />
            </svg>
            <strong><i>Clique</i> <i>aqui e </i> <i>leia mais</i></strong>
          </span>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
  <Popup
    texto="País recebeu pela primeira vez premiação dos 50 melhores restaurantes da América Latina. Prêmio criado em 2013 já passou por Peru, México, Argentina e Colômbia. Desta vez aconteceu, no Rio de Janeiro. A Casa do Porco foi o brasileiro melhor colocado na lista, na 4ª posição. O peruano Maido faturou o troféu em primeiro lugar"
    titulo="Brasil no centro da gastronomia"
    :imagem1="require('../assets/img/2023/popup1.png')"
    linkimagem1="https://www.estadao.com.br/paladar/restaurantes-e-bares/a-casa-do-porco-e-o-4-melhor-restaurante-da-america-latina-pelo-50-best/"
    :imagem2="require('../assets/img/2023/popup2.png')"
    linkimagem2="https://www.estadao.com.br/paladar/brasil-recebe-pela-primeira-vez-premiacao-dos-50-melhores-restaurantes-da-america-latina/"
    cor="rgba(35, 35, 120, 0.9 )"
  />
</template>
<script>
import Ano from "./Ano.vue";
import Popup from "./Popup.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox, Popup },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
      menupopup: false,
    };
  },
  methods: {
    handdleClick() {
      this.$store.commit("TOGGLE_MODAL", true);
      document.querySelector("body")?.classList.add("no-scroll");
    },
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require("@/assets/img/2023/2023-1.png"),
          title:
            "2021 - Casa de Carnes Mineira, em Anápolis (GO), onde José Batista Sobrinho, o sr. “Zé Mineiro”, deu início ao que é a JBS hoje.",
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 1fr 250px;
    gap: 30px;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    .click {
      position: absolute;
      bottom: 100px;
      left: -80px;
      max-width: 65px;
      cursor: pointer;
      @include media("<=desktop") {
        position: initial;
      }
      strong {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 116.5%;
        display: block;
        max-width: 50px;
        i {
          font-style: normal;
          background: color(cGreen);
          display: block;
          margin-bottom: 5px;
        }
      }
    }

    &__item {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      @include media("<=desktop") {
        padding: 0 20px;
        img {
          margin: 20px 0;
        }
      }

      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
        max-width: 640px;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
        max-width: 640px;
      }
      blockquote {
        color: color(cBlack);
        font-family: font(primary);
        font-family: JBS Text;
        font-size: 1rem;
        font-style: normal;
        font-weight: 700;
        line-height: 135%;
        margin: 10px 0;
        position: relative;
        max-width: 436px;
        span {
          font-weight: 400;
        }
        &::before {
          content: "\e901";
          font-family: "icomoon" !important;
          display: block;
          font-size: 1rem;
          line-height: initial;
          margin-bottom: 10px;
        }
      }

      &--black {
        position: relative;
        @include media("<=desktop") {
          padding: 30px 20px;
          background: color(cBlue5);
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          margin-top: 15px;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-bottom: 10px;
          margin-top: 15px;
        }
      }
    }
    &::after {
      content: "";
      background: color(cBlue5);
      width: 37%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
